import { PaymentMethodListDataInner } from "@wingspanhq/wingspan-api-sdk";

type PaymentMethodLabel = {
  icon: "card" | "bank";
  text: string;
};

/**
 * Describes one instrument from a payer's polymorphic payment-method collection.
 *
 * The collection mixes cards, external bank accounts and internal accounts. The
 * union is discriminated on members each variant *requires* — `accountName` on a
 * bank account, `name` on an internal account — leaving the card as the fallback.
 * `paymentMethodType` narrows nothing (every variant types it as the whole enum),
 * and the card's own distinguishing members (`brand`, `last4`) are all optional.
 */
export const selectorPaymentMethodLabel = (
  method: PaymentMethodListDataInner
): PaymentMethodLabel => {
  if ("accountName" in method) {
    const name = method.institutionName || method.accountName;
    return {
      icon: "bank",
      text: method.accountNumberMask
        ? `${name} (${method.accountNumberMask})`
        : name
    };
  }

  if ("name" in method) {
    return { icon: "bank", text: method.name };
  }

  const brand = method.brand || "Card";
  return {
    icon: "card",
    text: method.last4 ? `${brand} (${method.last4})` : brand
  };
};
